// ─────────────────────────────────────────────────────────
// MfaSetupDialog — zweiten Faktor einrichten, wo das Dashboard fehlt
// ─────────────────────────────────────────────────────────
// Der Server sperrt Plattform-Konten ohne zweiten Faktor aus (requirePlatformMfa,
// CASA 3.3.1). Die Einrichtung lebt aber in Einstellungen → Mein Konto, also im
// Firmen-Dashboard — das Plattform-Konten nie zu sehen bekommen. Ohne diesen
// Dialog wäre die Pflicht eine Sackgasse ohne Ausgang.
//
// Keine zweite Implementierung: dieselbe Karte (mfaCard) und dieselben Aktionen
// (handleMfaAction) wie in den Einstellungen, nur in einem eigenen Rahmen.
// Geöffnet wird er von apiClient, sobald eine Antwort MFA_SETUP_REQUIRED trägt.
// Prefix `mfa-dlg-`.
import { mfaCard, handleMfaAction } from '../company-dashboard/settingsAccount.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { t } from '../../i18n/index.js';
import './MfaSetupDialog.css';

let root = null;
let state = null;

function close() {
  root?.remove();
  root = null;
  state = null;
  document.removeEventListener('keydown', onKey);
}

function onKey(e) {
  // Solange Backup-Codes angezeigt werden, schliesst Escape NICHT — sie
  // erscheinen nur ein einziges Mal und sollen nicht versehentlich verschwinden.
  if (e.key === 'Escape' && !state?.mfaBackupCodes?.length) close();
}

function draw() {
  if (!root) return;
  const ctx = { s: state, draw };
  root.innerHTML = `
    <div class="mfa-dlg-backdrop" data-mfa-dlg="backdrop"></div>
    <div class="mfa-dlg" role="dialog" aria-modal="true" aria-labelledby="mfa-dlg-title">
      <div class="mfa-dlg-head">
        <h2 id="mfa-dlg-title">${escapeHtml(t('settings.account.mfaTitle'))}</h2>
        <button class="mfa-dlg-x" data-mfa-dlg="close" aria-label="${escapeHtml(t('common.close'))}">${icon('close', 20)}</button>
      </div>
      ${state.mfaBackupCodes?.length || state.mfa?.enabled ? '' : `<p class="cd-sc-lead">${escapeHtml(t('errors.MFA_SETUP_REQUIRED'))}</p>`}
      <div class="cd-emp">${mfaCard(ctx)}</div>
    </div>`;
}

function onClick(e) {
  const dlg = e.target.closest('[data-mfa-dlg]')?.dataset.mfaDlg;
  if (dlg === 'close' || (dlg === 'backdrop' && !state?.mfaBackupCodes?.length)) {
    close();
    return;
  }
  const el = e.target.closest('[data-action]');
  if (!el) return;
  const a = el.dataset.action;
  // Codes notiert → der Faktor ist aktiv. Neu laden, damit alle Plattform-
  // Ansichten, die eben noch mit 403 abgewiesen wurden, frisch laden.
  if (a === 'ac-mfa-codes-done') {
    close();
    window.location.reload();
    return;
  }
  handleMfaAction(a, el, { s: state, draw });
}

export function openMfaSetupDialog() {
  if (root) return; // schon offen — mehrere 403 gleichzeitig öffnen nur einen Dialog
  state = { mfa: null, mfaBusy: false, mfaError: '', mfaSetup: null, mfaBackupCodes: null, mfaLoading: false };
  root = document.createElement('div');
  root.className = 'mfa-dlg-root';
  root.addEventListener('click', onClick);
  document.body.appendChild(root);
  document.addEventListener('keydown', onKey);
  draw();
}

export function installMfaSetupPrompt() {
  window.addEventListener('lw:mfa-setup-required', openMfaSetupDialog);
}
